'use strict';

var jsxRuntime = require('react/jsx-runtime');
var react = require('react');
var utilities_combineClasses = require('./combineClasses-5P8GTQkg.js');
var components_tooltipIndicator_TooltipIndicator = require('../components/tooltipIndicator/TooltipIndicator.js');
var FieldContext = require('./FieldContext-DI94tJqT.js');

require("../_assets/Label-BF6fS_78.css");var styles = {"disabled":"Label__3jHwXzyEuK__disabled","label":"Label__3jHwXzyEuK__label","labelWrapper":"Label__3jHwXzyEuK__labelWrapper","required":"Label__3jHwXzyEuK__required","tooltipAnchor":"Label__3jHwXzyEuK__tooltipAnchor"};

const Label = react.forwardRef(({ className, required, disabled, testId = 'label', tooltip, tooltipIndicatorProps, children, ...props }, ref) => {
    const fieldContext = FieldContext.useFieldContext();
    const isRequired = required ?? fieldContext?.required;
    return (jsxRuntime.jsxs("div", { className: styles.labelWrapper, children: [jsxRuntime.jsxs("label", { ref: ref, 
                // the id on the label is used for setting aria-labelledby on elements that are not labelable
                // https://html.spec.whatwg.org/multipage/forms.html#category-label
                id: fieldContext?.labelId, htmlFor: fieldContext?.inputId, onClick: 
                // Because `Select` doesn't use real inputs, it can't use `htmlFor`, so we need to replicate this behaviour instead
                fieldContext?.inputType === 'select'
                    ? () => {
                        document
                            .querySelector(`#${fieldContext.inputId}`)
                            ?.focus();
                    }
                    : undefined, className: utilities_combineClasses.combineClasses(className, styles.label, disabled && styles.disabled), "data-testid": testId || undefined, ...props, children: [children, isRequired && (jsxRuntime.jsx("span", { "aria-hidden": true, className: styles.required, children: "*" }))] }), tooltip && (jsxRuntime.jsx("span", { children: jsxRuntime.jsx(components_tooltipIndicator_TooltipIndicator.TooltipIndicator, { text: tooltip, ...tooltipIndicatorProps, iconProps: {
                        ...tooltipIndicatorProps?.iconProps,
                        className: utilities_combineClasses.combineClasses(styles.tooltipAnchor, tooltipIndicatorProps?.iconProps?.className),
                    } }) }))] }));
});
Label.displayName = 'Label';

exports.Label = Label;
//# sourceMappingURL=Label-yBaxnb0E.js.map
